import {
  SET_LOADER_START,
  SET_LOADER_COMPLETE,
  SET_CATEGORY_LOADER_START,
  SET_CATEGORY_LOADER_COMPLETE
} from '../../constants';

const setLoaderStart = (name) => {
  return {
    type: SET_LOADER_START,
    payload: {
      name,
      status: true
    }
  };
}

const setLoaderComplete = (name) => {
  return {
    type: SET_LOADER_COMPLETE,
    payload: {
      name,
      status: false
    }
  };
}

const startItemLoader = (name, id) => ({
  type: SET_CATEGORY_LOADER_START,
  payload: { name, id, status: true }
});

const stopItemLoader = (name, id) => ({
  type: SET_CATEGORY_LOADER_COMPLETE,
  payload: { name, id, status: false }
});


export { setLoaderStart, setLoaderComplete,startItemLoader,stopItemLoader }